import React from 'react';

import { useIntl } from 'react-intl';

import SelectFilter from '../../../../../common/ui/filters/select-filter';
import { formatAvatarOptionLabel } from '../../../../../common/ui/filters/select-filter/option-label';
import { useSelectFilter } from '../../../../../controllers/filters/base-select-filter';
import { filter as assigneeFilter } from '../../../../../controllers/store/search/filters/assignee';
import { i18n } from './messages';

const AssigneeFilter = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	const [
		filterData,
		{ loadInitialOptions, setLookupInput, setOption, clearLookupInput, clearOptions },
	] = useSelectFilter({
		filterId: assigneeFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const {
		isLoading,
		suggestedOptions,
		selectedOptions,
		options,
		isLookupDefined,
		lookupInput,
		isLookupActive,
	} = filterData;

	const groupedOptions = [
		{
			label: formatMessage(i18n.jiraFilterAssigneeLabelSelected),
			options: selectedOptions,
		},
		{
			label: formatMessage(i18n.jiraFilterAssigneeLabelUnselected),
			options: suggestedOptions,
		},
	];

	return (
		<SelectFilter
			canClearFilter
			checkboxIndicators
			onDropdownOpen={loadInitialOptions}
			onDropdownClose={clearLookupInput}
			onSearchInputChange={setLookupInput}
			onSelectChange={setOption}
			options={isLookupActive ? options : groupedOptions}
			selectedOptions={selectedOptions}
			label={formatMessage(i18n.assignee)}
			placeholder={formatMessage(i18n.jiraFilterContributorPlaceholder)}
			filterOrControlId={'assignee'}
			isLoading={isLoading}
			isSearchable={isLookupDefined}
			searchInput={lookupInput}
			formatOptionLabel={formatAvatarOptionLabel}
			onClearOptions={clearOptions}
		/>
	);
};

export default AssigneeFilter;
